module.exports = __webpack_public_path__ + "static/media/function_introduction.3f1fe850.png";